module.exports = __webpack_public_path__ + "media/images/expert__selectedArrow--dark-cea050ee11fae9674368d34d945f12a7.png";